export default {
  'app.login.userName': 'userName',
  'app.login.password': 'password',
  'app.login.message-invalid-credentials': 'Invalid username or password（admin/ant.design）',
  'app.login.message-invalid-verification-code': 'Invalid verification code',
  'app.login.tab-login-credentials': 'Credentials',
  'app.login.tab-login-mobile': 'Mobile number',
  'app.login.remember-me': 'Remember me',
  'app.login.forgot-password': 'Forgot your password?',
  'app.login.sign-in-with': 'Sign in with',
  'app.login.signup': 'Sign up',
  'app.login.login': 'Login',
  'app.register.register': 'Register',
  'app.register.get-verification-code': 'Get code',
  'app.login.verification-code-warning':
    'This project is a demo project and will not actually send you a verification code. Please switch to the account password login interface and log in as prompted.',
  'app.register.sign-in': 'Already have an account?',
  'app.register-result.msg': 'Account：registered at {email}',
  'app.register-result.activation-email':
    'The activation email has been sent to your email address and is valid for 24 hours. Please log in to the email in time and click on the link in the email to activate the account.',
  'app.register-result.back-home': 'Back to home',
  'app.register-result.view-mailbox': 'View mailbox',
  'validation.email.required': 'Please enter your email!',
  'validation.email.wrong-format': 'The email address is in the wrong format!',
  'validation.userName.required': 'Please enter your userName!',
  'validation.password.required': 'Please enter your password!',
  'validation.password.twice': 'The passwords entered twice do not match!',
  'validation.password.strength.msg':
    "Please enter at least 6 characters and don't use passwords that are easy to guess.",
  'validation.password.strength.strong': 'Strength: strong',
  'validation.password.strength.medium': 'Strength: medium',
  'validation.password.strength.short': 'Strength: too short',
  'validation.confirm-password.required': 'Please confirm your password!',
  'validation.phone-number.required': 'Please enter your phone number!',
  'validation.phone-number.wrong-format': 'Malformed phone number!',
  'validation.verification-code.required': 'Please enter the verification code!',
  'validation.title.required': 'Please enter a title',
  'validation.date.required': 'Please select the start and end date',
  'validation.goal.required': 'Please enter a description of the goal',
  'validation.standard.required': 'Please enter a metric',
};
